
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { CorporateLeadsComponent } from './corporate-leads.component';
import { DialogComponent } from './dialog/dialog.component';
const routes: Routes = [
    {
        path     : 'corporate-leads',
        component: CorporateLeadsComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        CorporateLeadsComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class CorporateLeadsModule
{
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-leads/corporate-leads.module.ts